import { render } from "./BarChartD.vue?vue&type=template&id=0d5d8de0&scoped=true"
import script from "./BarChartD.vue?vue&type=script&lang=ts"
export * from "./BarChartD.vue?vue&type=script&lang=ts"

import "./BarChartD.vue?vue&type=style&index=0&id=0d5d8de0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0d5d8de0"

export default script